module.exports = __webpack_public_path__ + "static/img/kylogo.00dbe07.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kylogo.jpeg
// module id = 271
// module chunks = 2 3